/// <reference types="@types/googlemaps" />
import { Subject } from 'rxjs';

import { SearchResult } from '../../+state/service-locator/service-locator.models';

export class MapMarker {
  private marker: google.maps.Marker;
  private dragEnd$: Subject<any> = new Subject<any>();
  private dragStart$: Subject<any> = new Subject<any>();
  private markerClicked$: Subject<void> = new Subject<any>();
  private shop: SearchResult;

  constructor(
    private map: google.maps.Map,
    opts: google.maps.MarkerOptions,
    shop?: SearchResult
  ) {
    // Create the Marker
    this.marker = new google.maps.Marker(opts);
    this.marker.setMap(this.map);

    // Attach the shop if we have one
    if (shop) {
      this.shop = shop;
    }
  }

  public getMarker() {
    return this.marker;
  }

  public getShop() {
    return this.shop;
  }
  /**
   * if marker is draggable, emit out the move event
   */
  public addDragEvents() {
    const self = this;
    this.marker.addListener('dragstart', event => {
      self.dragStart$.next(event);
    });

    this.marker.addListener('dragend', event => {
      const emitValue = {
        moved: true,
        event: event
      };
      self.dragEnd$.next(emitValue);
    });
  }

  public setPosition(pos: any, overlay?) {
    this.marker.setPosition(pos);
    if (overlay) {
      overlay.updateOverlayPosition(pos);
    }
  }

  public setMarkerDraggable(drag: boolean) {
    this.marker.setDraggable(drag);
  }

  //  TODO: update scope var SELF
  public addClickEvent() {
    const self = this;
    this.marker.addListener('click', event => {
      self.markerClicked$.next();
    });
  }

  public dragEndedEvent$() {
    return this.dragEnd$;
  }

  public dragStartedEvent$() {
    return this.dragStart$;
  }

  public markerClickedEvent$() {
    return this.markerClicked$;
  }

  public clearMarker() {
    this.marker.setMap(null);
  }
}
